import UpdatePassword from "../../../components/@account/UpdatePassword";

import { routeTypes } from "../../../hooks/useSystemRoutes";

export default function PasswordPage() {

    return (
        <UpdatePassword 
            routeType={routeTypes.retail}
        />
    )
}       